// extracted by mini-css-extract-plugin
export default {"EmptyList":"TPOEmptyTableTypography_EmptyList__-gyT9"};